import React from 'react';
import styles from './LoginStyles.module.scss';

const LoginButton = ({ children, ...rest }) => {
  return (
    <button className={`${styles.generalLoginButton} ${styles.loginButton}`} {...rest}>
      {children}
    </button>
  );
};

export default LoginButton;
